import { http } from '../http';
import { transformBlockListRow } from 'BlockList/utils/transformBlockListRow';
import type { BlockedAttribute, BlockListRow } from 'BlockList/types';
import type { CreateBlockedAttributePayload } from '../PostBlockListAttribute';

// ---------------------------------------------------------------------------
// Request shapes
// ---------------------------------------------------------------------------

type BatchPayloadItem = CreateBlockedAttributePayload & {
  policy_id?: string;
  policy_number?: string;
};

export type BatchCreateBlockedAttributePayload = {
  attributes: BatchPayloadItem[];
};

// ---------------------------------------------------------------------------
// Response shape (snake_case wire) — wrapped in { data: BlockedAttribute[] }
// ---------------------------------------------------------------------------

type ServerResponse = {
  data: BlockedAttribute[];
};

// ---------------------------------------------------------------------------
// Service function — transforms wire → domain (BlockListRow[]) so consumers
// receive the same camelCase shape as other blocklist endpoints.
// ---------------------------------------------------------------------------

export const postBlockListAttributesBatch = (
  token: string,
  payload: BatchCreateBlockedAttributePayload
) =>
  http.post<BlockListRow[]>(
    {
      url: '/clearcover_admin/blocklist/attributes/batch',
      token,
      transformResponse: (jsonData: unknown): unknown => {
        const raw =
          typeof jsonData === 'string' ? JSON.parse(jsonData) : jsonData;
        // axios runs transformResponse on every status code; error payloads
        // (e.g. 422 BatchErrorResponse) pass through untouched so the catch
        // path can read the server message.
        if (
          !raw ||
          typeof raw !== 'object' ||
          !Array.isArray((raw as { data?: unknown }).data)
        ) {
          return raw;
        }
        return ((raw as ServerResponse).data as BlockedAttribute[]).map(
          transformBlockListRow
        );
      },
    },
    payload
  );
